import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Form, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Loader from '../components/Loader'
import Message from '../components/Message'
import FormContainer from '../components/FormContainer'
import { requestPasswordReset, resetPasswordRequestReset } from '../actions/passwordResetActions'

function ForgotPasswordScreen() {
    const { t } = useTranslation()
    const [email, setEmail] = useState('')
    const [submitted, setSubmitted] = useState(false)

    const dispatch = useDispatch()

    const passwordResetRequest = useSelector(state => state.passwordResetRequest)
    const { loading, error, success, message } = passwordResetRequest

    useEffect(() => {
        // Reset state when component unmounts
        return () => {
            dispatch(resetPasswordRequestReset())
        }
    }, [dispatch])

    useEffect(() => {
        if (success) {
            setSubmitted(true)
        }
    }, [success])

    const submitHandler = (e) => {
        e.preventDefault()
        dispatch(requestPasswordReset(email))
    }

    return (
        <FormContainer>
            <h1>{t('forgotPassword.title')}</h1>
            
            {!submitted ? (
                <>
                    <p>{t('forgotPassword.description')}</p>
                    
                    {error && <Message variant='danger'>{error}</Message>}
                    {loading && <Loader />}

                    <Form onSubmit={submitHandler}>
                        <Form.Group controlId='email' className='my-3'>
                            <Form.Label>{t('forgotPassword.email')}</Form.Label>
                            <Form.Control
                                type='email'
                                placeholder={t('forgotPassword.emailPlaceholder')}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            ></Form.Control>
                        </Form.Group>

                        <Button type='submit' variant='primary' disabled={loading}>
                            {t('forgotPassword.submit')}
                        </Button>
                    </Form>

                    <Row className='py-3'>
                        <Col>
                            {t('forgotPassword.remember')} <Link to='/login'>{t('forgotPassword.signIn')}</Link>
                        </Col>
                    </Row>
                </>
            ) : (
                <>
                    <Message variant='success'>
                        {message || t('forgotPassword.sent')}
                    </Message>
                    
                    <p>
                        {t('forgotPassword.spamNote')}
                    </p>

                    <Button 
                        variant='secondary' 
                        onClick={() => {
                            setSubmitted(false)
                            setEmail('')
                            dispatch(resetPasswordRequestReset())
                        }}
                        className='me-2'
                    >
                        {t('forgotPassword.sendAnother')}
                    </Button>
                    
                    <Link to='/login'>
                        <Button variant='primary'>
                            {t('forgotPassword.backToLogin')}
                        </Button>
                    </Link>
                </>
            )}
        </FormContainer>
    )
}

export default ForgotPasswordScreen
